<template>
  <div class='animated fadeIn'>
    <b-row class='justify-content-md-center mb-5'>
      <b-col cols='12' lg='10'>
        <b-card class='shadow-sm bg-white rounded' border-variant='light'>
          <div>
            <el-button type='warning' icon='el-icon-back' circle @click='goBack'></el-button>
          </div>
          <b-card-body class='pl-0 pr-0'>
            <b-row>
              <b-col>
                <div class='table-responsive'>
                  <b-table
                    :items='member'
                    :fields='fields'
                    :current-page='currentPage'
                    :per-page='perPage'>
                    <div slot='icon' class='avatar' slot-scope='item' style="width:40px;">
                      <b-img v-if='item.value' :src='item.value'></b-img>
                      <!-- <b-img v-else src='../admin.png' class='img-avatar'></b-img> -->
                    </div>
                    <div slot='key' slot-scope='item'>
                      <div v-if="getStatus(item) === null" class='mr-auto align-middle'>
                        <el-button type='success' icon='el-icon-plus' style='outline:none;' circle v-on:click.stop="addButton(item)"></el-button>
                      </div>
                    <div v-if="getStatus(item) === 'pending'" class="ml-auto p-2"><el-button size='small' type="danger" round disabled >Pending</el-button></div>
                    <div v-else-if="getStatus(item) === 'requesting'" class="ml-auto p-2"><el-button size='small' type="success" round style="outline:none;" v-on:click.stop="accept(ref)">Accept</el-button></div>
                    </div>
                  </b-table>
                </div>
                <b-pagination align='center' size='sm' :total-rows='member.length' v-model='currentPage' :per-page='perPage'></b-pagination>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref='errorModal' centered title='チャットメンバー' class='text-primary' size="sm" ok-variant=primary header-bg-variant=primary>
      <p class='my-4'>{{errorMessage}}</p>
    </b-modal>
    <b-modal id='modal-center'
            ref='modal'
            title='チャットメンバー'
            @ok='request()'
            centered
            header-bg-variant='primary'
            body-text-variant='primary'
            ok-variant='primary'
            size='sm'
            class='px100-btn'
          >
      <p class='my-4'>{{ 'リクエストを送信します' }}</p>
      <p class='my-4'>よろしいですか?</p>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { mapGetters } from 'vuex'
export default {
  data: () => {
    return {
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center',
          sortable: true
        },
        status: {
          label: '私のスローガン',
          class: 'text-center',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      member: [],
      currentPage: 1,
      perPage: 10,
      errorMessage: '',
      routine: null,
      unwatch: null,
      unwatch1: null,
      item: null
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
    if (this.unwatch1) {
      this.unwatch1()
      this.unwatch1 = null
    }
  },
  created () {
    this.unwatch = this.$store.watch(state => this.$store.getters['chatRef/chatRef'], value => {
      this.init()
    })
    this.unwatch1 = this.$store.watch(state => this.$store.getters['user/users'], value => {
      this.init()
    })
    this.init()
  },
  methods: {
    init () {
      this.member = []
      for (var index in this.users) {
        var user = this.users[index]
        if (user.key !== this.user.key) {
          this.member.push(user)
        }
      }
      this.member.sort(function (a, b) {
        if (a.name < b.name) return -1
        if (a.name < b.name) return 1
        return 0
      })
    },
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    goBack () {
      this.$router.go(-1)
    },
    addButton (value) {
      this.item = value
      this.$refs.modal.show()
    },
    getStatus (value) {
      for (var index in this.chatRef) {
        var ref = this.chatRef[index]
        if (ref.key === value.item.key) {
          return ref.status
        }
      }
      return null
    },
    request () {
      var vm = this
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      const batch = db.batch()

      var refChats = db.collection('chats').doc()
      batch.set(refChats, { 'unread': {}, 'read': {}, 'last': null, 'createdAt': parseInt(new Date().getTime() / 1000) })

      var refChatsRefFrom = db.collection('chats_refs').doc(vm.user.key).collection('refs').doc(this.item.item.key)
      batch.set(refChatsRefFrom,
        {
          'location': refChats.id,
          'type': 'user',
          'status': 'pending',
          'enable': false,
          'createdAt': parseInt(new Date().getTime() / 1000),
          'updatedAt': parseInt(new Date().getTime() / 1000)
        }
      )
      var refChatsRefTo = db.collection('chats_refs').doc(this.item.item.key).collection('refs').doc(vm.user.key)
      batch.set(refChatsRefTo,
        {
          'location': refChats.id,
          'type': 'user',
          'status': 'requesting',
          'enable': false,
          'createdAt': parseInt(new Date().getTime() / 1000),
          'updatedAt': parseInt(new Date().getTime() / 1000)
        }
      )
      batch.commit().then(function () {
        vm.$router.go(-1)
      })
    }
  },
  computed: {
    ...mapGetters({
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      user: 'authUser/user',
      chatRef: 'chatRef/chatRef',
      chatMessage: 'chatMessage/chatMessage'
    })
  }
}
</script>

<style>
table td {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatMember.vue